import React, { useState, useEffect } from 'react'
import {
  ChampSeriesScheduleCon,
  CSDayHeader,
  CSGameRow,
} from '../styles'
import { GameAction } from '../../../../Components/Buttons/GameAction'
import {
  getBroadcastImg,
  getGameTimeLocal,
  mapChampSeriesEvents,
} from '../../../../Utils'
import { TeamsCol } from '../../components/weekBox/TeamsCol'
import { fetchWLLSeasonEvents, type EventGQL } from '../../../../Api'
import { Desc, Head3 } from '../../../../Components/Typography/Text.styles'
import { BROADCASTER_LINKS, PLL_IMAGES } from '../../../../Config/config'
import { Lk } from '../../../../Components/Links/Lk'
import { Img } from '../../../../Components/Image/Img'
import { BroadcastCon } from '../../components/weekBox/weekStyles'
import { EVENTS_YEAR } from '../../../../Config/League/league.config'

export const ChampSeriesEventsCon: React.FC<{ events: EventGQL[] }> = ({ events }) => {
  const [champEventObj, setChampEventObj] = useState<{
    [key: string]: EventGQL[]
  } | null>(null)
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    if(!events || !loading) return
    getAllCSEvents(events)
  }, [events])

  const getAllCSEvents = async (events: EventGQL[]) => {
    let mappedCSEvents: {[key: string]: EventGQL[]} | null = null
    const wllEvents = await fetchWLLSeasonEvents(EVENTS_YEAR, true)
    if (wllEvents && wllEvents.length > 0) {
      let allEvents = [...events, ...wllEvents].sort((a, b) => a.startTime - b.startTime)
      mappedCSEvents = mapChampSeriesEvents(allEvents, 'day')
    } else {
      mappedCSEvents = mapChampSeriesEvents(events, 'day')
    }
    setChampEventObj(mappedCSEvents)
    setLoading(false)
}
  
  const getGameDesc = (event: EventGQL) => {
    if (!event.description) return
    if (event.description.toLowerCase().includes('semi')) {
      return 'Semifinals'
    }
    if (event.description.toLowerCase().includes('champ')) {
      return 'Championship'
    }
    return
  }

  return (
    <>
      <ChampSeriesScheduleCon>
        {champEventObj &&
          Object.keys(champEventObj).map((day, idx) => (
            <div className="dayGameCon" key={idx}>
              <CSDayHeader>
                <Head3 sideMargins={2}>{day}</Head3>
                <Desc sideMargins={2}>{getGameDesc(champEventObj[day][0])}</Desc>
              </CSDayHeader>
              {champEventObj[day].map((event) => (
                <CSGameRow key={event.slugname}>
                  <div className="leagueCol">
                    <Img src={event.league === 'WLL' ? PLL_IMAGES.wllShield : PLL_IMAGES.pllShield} alt="WLL League" />
                  </div>
                  <div className="gameTimeCol">
                    <p>{getGameTimeLocal(event.startTime)}</p>
                    <BroadcastCon>
                      <Lk
                        link={event.urlStreaming || BROADCASTER_LINKS.generalESPNPlus}
                        alt="Broadcaster icons"
                      >
                        {getBroadcastImg(event.broadcaster).map((img, idx) => (
                          <Img
                            key={idx}
                            className="broadcaster"
                            src={img}
                            alt="Broadcaster"
                          />
                        ))}
                      </Lk>
                    </BroadcastCon>
                  </div>
                  <div className="teamCol">
                    <TeamsCol description={event.description} event={event} />
                  </div>
                  <div className="actionCol">
                    {event.awayTeam && (
                      <GameAction event={event} section={'cs_schedule'} />
                    )}
                  </div>
                </CSGameRow>
              ))}
            </div>
          ))}
      </ChampSeriesScheduleCon>
    </>
  )
}
